import { memo } from 'react';

import { asyncBeforeEnquiryAdd } from '@lcsc-ui/apis/order';
import SvgIcon from '@lcsc-ui/components/SvgIcon';
import Utils from '@lcsc-ui/utils/Utils';
import { Input, Form, message } from 'antd';
import { styled } from 'styled-components';

const CustomDiv = styled.div`
  margin-top: 16px;
  .ant-form-item {
    margin-bottom: 16px;
    height: 38px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding: 2px 6px 0;
  }
  .expect-price-form-item {
    padding-left: 16px;
  }
`;

const ItemRightInquiry = ({ data }) => {
  const [form] = Form.useForm();

  const defaultProductModel = data?.productRecord.model || data?.productRecord.productModel || '';

  const defaultBrandName = data?.productRecord.brandName || data?.productRecord.productGradePlateName || '';

  const handleSubmit = async () => {
    const values = await form.getFieldsValue();
    if (!values.productModel) {
      form.setFieldsValue({ productModel: defaultProductModel });
    }
    if (!values.brandName) {
      form.setFieldsValue({ brandName: defaultBrandName });
    }
    form.submit();
  };

  const handleFinish = async (values) => {
    const { productModel, brandName, expectNumber, expectPrice } = values;
    const res = await asyncBeforeEnquiryAdd({
      params: JSON.stringify({
        productModel,
        brandName,
        expectNumber,
        expectPrice,
      }),
    });
    if (res?.needLogin) {
      Utils.showWindowLogin();
      return;
    }
    if (res?.code === 200) {
      message.success('已提交询价');
    } else {
      message.error(res?.msg);
    }
  };

  return (
    <section className="ml-[20px] w-[370px] rounded-[20px] bg-[#FFFFFF] px-[20px] py-[30px]">
      <div className="flex items-center px-[12px] h-[40px] bg-[#E6F4FF] rounded-[4px]">
        <SvgIcon app="item" iconName="mark-circle-fill" className="w-[16px] h-[16px]" />
        <span className="ml-[8px]">当前商品已下架 如需订货请填写您的需求</span>
      </div>
      <CustomDiv>
        <Form form={form} autoComplete="off" preserve={false} onFinish={handleFinish}>
          <Form.Item
            label="型号"
            name="productModel"
            colon={false}
            rules={[{ required: true, message: '请输入商品型号' }]}
          >
            <Input bordered={false} placeholder={defaultProductModel || '请输入型号'} maxLength={100} />
          </Form.Item>
          <Form.Item label="品牌" name="brandName" colon={false} rules={[{ required: true, message: '请输入品牌' }]}>
            <Input bordered={false} placeholder={defaultBrandName || '请输入品牌'} maxLength={32} />
          </Form.Item>
          <Form.Item
            label="数量"
            name="expectNumber"
            colon={false}
            rules={[
              {
                required: true,
                message: '请输入数量',
              },
              {
                pattern: /^[1-9]\d*$/,
                message: '请输入正确数量',
              },
            ]}
          >
            <Input bordered={false} placeholder={'请输入数量'} maxLength={8} />
          </Form.Item>
          <Form.Item
            className="expect-price-form-item"
            label="期望单价"
            name="expectPrice"
            colon={false}
            rules={[
              {
                required: false,
              },
              {
                validator: (_, value) => {
                  if ((value && isNaN(value)) || parseFloat(value) <= 0) {
                    return Promise.reject('请输入正确价格');
                  } else if (value && Number(value.split('.')[0]) > 1000000) {
                    return Promise.reject('整数最大支持1000000');
                  } else if (value && value.includes('.') && value.split('.')[1].length > 6) {
                    return Promise.reject('小数最多支持6位');
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input bordered={false} placeholder={'请输入期望单价(元)'} maxLength={14} />
          </Form.Item>
          <button
            type="button"
            onClick={handleSubmit}
            className="mt-[14px] bg-[#0093E6] text-[#FFFFFF] rounded-[24px] w-[330px] h-[48px] hover:opacity-80 text-[16px]"
          >
            我要询价
          </button>
        </Form>
      </CustomDiv>
    </section>
  );
};

export default memo(ItemRightInquiry);
